import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TransferOutlineIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TransferOutlineIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M19.965 12.0584C19.8634 12.0584 19.7618 12.0377 19.6656 11.9965C19.0694 11.7119 16.1458 10.3927 12.8095 10.3927C9.46786 10.3927 6.54875 11.7119 5.99761 11.9759C5.76401 12.0888 5.47984 12.075 5.26146 11.9386C5.04208 11.8002 4.90073 11.5637 4.90073 11.3045V7.16732C4.90073 5.2749 6.4398 3.73584 8.33172 3.73584H17.2878C19.1798 3.73584 20.7188 5.2749 20.7188 7.16732V11.3045C20.7188 11.5588 20.5912 11.7953 20.3787 11.9347C20.2541 12.0162 20.1098 12.0584 19.965 12.0584ZM12.8095 8.88501C15.4523 8.88501 17.8527 9.6359 19.2112 10.163V7.1673C19.2112 6.10625 18.3484 5.24347 17.2878 5.24347H8.33172C7.27116 5.24347 6.40839 6.10625 6.40839 7.1673V10.162C7.76293 9.63589 10.1628 8.88501 12.8095 8.88501Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.3913 20.2641H17.7776C17.4262 20.2641 17.0822 20.1208 16.8349 19.8715L15.8028 18.831H9.81679L8.78372 19.8715C8.53833 20.1208 8.1943 20.2641 7.84143 20.2641H6.22826C5.49603 20.2641 4.90072 19.6683 4.90072 18.937L4.90073 11.3045C4.90073 11.0523 5.02636 10.8177 5.23593 10.6773C5.445 10.5379 5.711 10.5095 5.94313 10.6086C6.55659 10.8991 9.4924 12.2164 12.8095 12.2164C16.1232 12.2164 19.061 10.8991 19.6166 10.6351C19.8497 10.5232 20.1353 10.533 20.3552 10.6734C20.5736 10.8108 20.7188 11.0464 20.7188 11.3045L20.7183 18.937C20.7183 19.6683 20.123 20.2641 19.3913 20.2641ZM17.8527 18.7564H19.2107V12.448C17.8277 12.9879 15.4548 13.724 12.8095 13.724C10.1756 13.724 7.76832 12.9712 6.40839 12.4451V18.7564H7.76635L8.79943 17.716C9.04874 17.4637 9.38344 17.3234 9.74122 17.3234H15.8778C16.2346 17.3234 16.5693 17.4627 16.8206 17.716L17.8527 18.7564Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.4147 12.0584H19.965C19.7368 12.0584 19.5199 11.9543 19.3771 11.7767C19.2338 11.599 19.1793 11.3654 19.2284 11.1426L19.8624 8.26664C19.9385 7.92114 20.2447 7.67477 20.5986 7.67477H22.0557C22.2844 7.67477 22.5008 7.77882 22.6436 7.95745C22.787 8.13512 22.8414 8.36971 22.7914 8.59252L22.1504 11.4684C22.0739 11.813 21.7681 12.0584 21.4147 12.0584Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.65456 12.0584H4.19745C3.84361 12.0584 3.53736 11.812 3.4613 11.4665L2.82722 8.59055C2.77814 8.36774 2.83261 8.13413 2.97592 7.95647C3.11874 7.77881 3.33517 7.67477 3.56337 7.67477H5.01361C5.36696 7.67477 5.67271 7.92015 5.74927 8.26467L6.39023 11.1406C6.44028 11.3634 6.38581 11.598 6.24251 11.7757C6.09969 11.9543 5.88326 12.0584 5.65456 12.0584Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TransferOutlineIcon;
